module.exports = __webpack_public_path__ + "img/icon-amount-pellets-palet-dark.3bd2849.svg";